// =========================================
// SavInvest — English Translations
// =========================================

const en = {
  // Navigation
  nav: {
    dashboard: 'Dashboard',
    purchases: 'Purchases',
    sales: 'Sales',
    products: 'Products',
    campaigns: 'Campaigns',
    investments: 'Investments',
    partners: 'Partners',
    profile: 'My Profile',
    logout: 'Logout',
    companies: 'Companies',
    cagnotte: 'Pool Fund',
  },

  // Auth
  auth: {
    login: 'Sign In',
    register: 'Create Account',
    email: 'Email',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    nom: 'Last Name',
    prenom: 'First Name',
    tel: 'Phone',
    role: 'Role',
    investor: 'Owner',
    partner: 'Partner',
    loginTitle: 'Welcome to SavInvest',
    loginSubtitle: 'Sign in to manage your investments',
    registerTitle: 'Create an Account',
    registerSubtitle: 'Join SavInvest and manage your finances',
    alreadyHaveAccount: 'Already have an account?',
    noAccount: "Don't have an account?",
    forgotPassword: 'Forgot password?',
    step1: 'Personal Information',
    step2: 'Your Company',
    step3: 'Confirmation',
    joinExistingCompany: 'Join an existing company',
    createNewCompany: 'Create a new company',
    noCompany: 'No company',
  },

  // Dashboard
  dashboard: {
    title: 'Dashboard',
    subtitle: 'Overview of your activity',
    totalSales: 'Total Sales',
    totalPurchases: 'Total Purchases',
    totalInvestments: 'Total Investments',
    benefice: 'Overall Net Profit',
    revient: 'Revenue (Sales - Purchases)',
    revientSub: 'Gross trading margin',
    diffInvestAchats: 'Balance (Invested - Purchases)',
    diffInvestAchatsSub: 'Remaining unspent capital',
    totalCampaigns: 'Campaigns',
    investors: 'Owners',
    partners: 'Partners',
    stock: 'Products',
    stockAlert: 'Stock Alerts',
    stockAlertTitle: 'Stock Level Alerts',
    stockAlertWarning: 'Some products require your attention (low or out of stock).',
    stockAllGood: 'All stock levels are optimal ✓',
    evolution: 'Timeline Evolution',
    salesEvolution: 'Sales Evolution',
    purchasesEvolution: 'Purchases Evolution',
    profitLoss: 'Profit & Loss',
    filterByCampaign: 'Filter by campaign',
    allCampaigns: 'All campaigns',
    filterByDate: 'Period & Dates',
    dateDebut: 'From',
    dateFin: 'To',
    periodAll: 'All',
    period7d: '7 days',
    period30d: '30 days',
    periodMonth: 'This month',
    periodYear: 'This year',
    resetFilters: 'Reset',
    myRevenues: 'My Revenues',
    myRevenuesSub: 'My share of the net profit',
    myShare: '% of shares',
    marginPositive: '✓ Positive Margin',
    marginNegative: '↓ Negative Margin',
    capitalAvailable: '✓ Capital Available',
    budgetOverrun: '⚠ Budget Exceeded',
    beneficeFormula: 'Sales − Investments',
    salesFormula: 'Sales',
    purchasesFormula: 'Purchases',
    investedFormula: 'Invested',
    consumed: 'used',
    profitFormula: 'Profit',
    sharesTotal: 'Σ Shares',
    sharesBalanced: '✓ Balanced',
    sharesAbove: 'of total',
    noShareAssigned: 'No shares assigned — define percentages in profiles.',
    beneficeByCampaign: 'Profit by Campaign — Share Breakdown',
    sharesBreakdown: 'SHARE BREAKDOWN',
    stockManagement: 'Stock Management',
    stockOutOf: 'out-of-stock product(s)',
    stockAllAvailable: 'All stock available',
    stockOutBanner: 'Out of stock',
    stockRefillPrompt: 'These products are exhausted, please restock.',
    stockStatusOut: 'Out of stock',
    stockStatusLow: '⚠ Low',
    stockStatusOk: 'In stock',
    myInvestmentsByCampaign: 'My investments by campaign',
    colCampaign: 'Campaign',
    colAmount: 'Amount',
    colDate: 'Date',
    colShare: 'Share (%)',
    colProduct: 'Product',
    colQty: 'Quantity',
    colSalePrice: 'Sale price',
    colStockValue: 'Stock value',
    colStatus: 'Status',
    margin: 'Margin',
  },

  // Products
  products: {
    title: 'Product Management',
    add: 'Add Product',
    edit: 'Edit Product',
    libelle: 'Product Name',
    quantite: 'Stock Quantity',
    prixVente: 'Unit Selling Price (FCFA)',
    valeurStock: 'Stock Value',
    noProducts: 'No products registered',
    delete: 'Delete',
    save: 'Save',
    cancel: 'Cancel',
  },

  // Purchases
  purchases: {
    title: 'Purchase Management',
    add: 'Add Purchase',
    produit: 'Product',
    quantite: 'Quantity',
    prixUnitaire: 'Unit Purchase Price (FCFA)',
    total: 'Total (FCFA)',
    date: 'Date',
    campagne: 'Associated Campaign',
    noPurchases: 'No purchases recorded',
  },

  // Sales
  sales: {
    title: 'Sales Management',
    add: 'Add Sale',
    client: 'Client',
    produit: 'Product',
    quantite: 'Quantity',
    prixVente: 'Unit Price (FCFA)',
    total: 'Total (FCFA)',
    date: 'Date',
    campagne: 'Associated Campaign',
    noSales: 'No sales recorded',
    stockInsuffisant: 'Insufficient stock',
  },

  // Campaigns
  campaigns: {
    title: 'Campaigns',
    add: 'New Campaign',
    libelle: 'Title',
    description: 'Description',
    dateDebut: 'Start Date',
    dateFin: 'End Date',
    budgetInitial: 'Initial Budget (FCFA)',
    totalInvesti: 'Total Invested',
    statut: 'Status',
    active: 'Active',
    closed: 'Closed',
    noCampaigns: 'No campaigns',
  },

  // Investments
  investments: {
    title: 'Investments',
    add: 'Add Investment',
    campagne: 'Campaign',
    montant: 'Amount (FCFA)',
    pourcentage: 'Share (%)',
    date: 'Date',
    notes: 'Notes',
    noInvestments: 'No investments',
  },

  // Partners
  partners: {
    title: 'Partner Management',
    add: 'Add Partner',
    edit: 'Edit Partner',
    name: 'Full Name',
    email: 'Email',
    tel: 'Phone',
    password: 'Temporary Password',
    company: 'Affiliated Company',
    role: 'Role',
    noPartners: 'No partners recorded',
    remove: 'Remove',
    createPartnerTitle: 'Create Partner Account',
    createPartnerSubtitle: 'This partner will be able to log in to the platform',
  },

  // Profile
  profile: {
    title: 'My Profile',
    subtitle: 'Manage your personal details, photo, and security',
    personalInfo: 'Personal Information',
    photoAvatar: 'Profile Picture',
    changePhoto: 'Change photo',
    removePhoto: 'Remove',
    photoHint: 'Accepted formats: JPG, PNG, WebP (max 5 MB)',
    companyInfo: 'My Company',
    security: 'Security & Password',
    currentPassword: 'Current Password',
    newPassword: 'New Password',
    confirmNewPassword: 'Confirm New Password',
    passwordHint: 'Leave empty if you do not wish to change your password',
    saveSuccess: 'Profile updated successfully ✓',
    roleInvestorBadge: '👑 Owner',
    rolePartnerBadge: '🤝 Partner',
  },

  // Stats
  stats: {
    transactions: 'transactions',
    fcfa: 'FCFA',
    vs: 'vs previous period',
    profit: 'Profitable',
    loss: 'Loss',
    stockLow: 'Low stock',
  },

  // Common
  common: {
    save: 'Save',
    saveChanges: 'Save Changes',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    add: 'Add',
    close: 'Close',
    confirm: 'Confirm',
    search: 'Search...',
    loading: 'Loading...',
    noData: 'No data available',
    actions: 'Actions',
    total: 'Total',
    success: 'Success',
    error: 'Error',
    required: 'Required field',
    next: 'Next',
    previous: 'Previous',
    submit: 'Submit',
    welcome: 'Welcome',
    hello: 'Hello',
  },

  // Company
  company: {
    title: 'Company',
    libelle: 'Company Name',
    capacite: 'Capacity',
    pays: 'Country',
    ville: 'City',
    description: 'Description',
    domaine: 'Business Domain',
  },

  // Cagnotte / Shared Fund
  cagnotte: {
    title: 'My Pool Funds',
    subtitle: 'Manage your shared funds and monthly contributions',
    add: 'New Pool Fund',
    edit: 'Edit Pool Fund',
    libelle: 'Fund name',
    description: 'Description',
    objectifMensuel: 'Monthly target per member',
    devise: 'Currency',
    statut: 'Status',
    active: 'Active',
    closed: 'Closed',
    noCagnottes: 'No funds yet. Create one or wait for an invitation.',
    total: 'Total collected',
    solde: 'Available balance',
    depenses: 'Total expenses',
    membres: 'Members',
    cotisations: 'Contributions',
    operations: 'Operations',
    bankInfo: 'Bank Account',
    mobileMoneyInfo: 'Mobile Money',
    compteBancaire: 'Account number',
    banqueNom: 'Bank name',
    mobileNumero: 'Mobile Money number',
    mobileType: 'Provider (Wave, Orange Money...)',
    mobileLien: 'Payment link (URL)',
    invite: 'Invite a member',
    inviteEmail: 'Email to invite',
    logCotisation: 'Log my contribution',
    logCotisationFor: 'Log for a member',
    logOperation: 'Add an operation',
    cotisationMontant: 'Contribution amount',
    cotisationMois: 'Month (YYYY-MM)',
    cotisationNote: 'Note',
    operationLibelle: 'Operation label',
    operationMontant: 'Amount',
    operationType: 'Type',
    operationDate: 'Date',
    operationNote: 'Note',
    typeDepense: 'Expense',
    typeRetrait: 'Withdrawal',
    typeRemboursement: 'Reimbursement',
    typeAutre: 'Other',
    memberSince: 'Member since',
    paid: 'Paid',
    notPaid: 'Not paid',
    matrixTitle: 'Contribution tracking',
    adminBadge: '\ud83d\udc51 Admin',
    inviteSuccess: 'Invitation sent!',
    inviteLinkCopied: 'Link copied to clipboard',
    deleteConfirm: 'Permanently delete this fund?',
    removeMemberConfirm: 'Remove this member?',
  },
};

export default en;
